import { apiClient } from './api.js';
import { unwrap } from './api-error.js';
import type { ApiPaths } from '@reos/api-client';

/** Kolegove v tenantu (avatar/inicialy na kanban karte, filtr "dle maklere" - R4). */
export type TenantMember = ApiPaths['/v1/members']['get']['responses']['200']['content']['application/json']['items'][number];

export async function listMembers(): Promise<TenantMember[]> {
  const result = await unwrap(apiClient.GET('/v1/members', {}));
  return result.items;
}

/**
 * Krok QAFIX4b bod 2 — obrazovka Nastavení → Tým. Pozvánka odchází e-mailem
 * (na preview do mailpitu) a `acceptUrl` se dá zkopírovat, když e-mail
 * nedojde.
 */
export type InviteMemberInput = ApiPaths['/v1/members/invite']['post']['requestBody'] extends {
  content: { 'application/json': infer B };
}
  ? B
  : never;

export async function inviteMember(
  input: InviteMemberInput,
): Promise<{ invitationId: string; acceptUrl: string; emailSent: boolean }> {
  return unwrap(apiClient.POST('/v1/members/invite', { body: input }));
}

export type UpdateMemberInput = ApiPaths['/v1/members/{userId}']['patch']['requestBody'] extends {
  content: { 'application/json': infer B };
}
  ? B
  : never;

/** Změna role / pobočky / deaktivace. Člen se NEMAŽE (historie, audit). */
export async function updateMember(
  userId: string,
  input: UpdateMemberInput,
): Promise<TenantMember> {
  return unwrap(
    apiClient.PATCH('/v1/members/{userId}', { params: { path: { userId } }, body: input }),
  );
}
